// /src/lib/rating.ts
export function stars(rating?: number): string {
  if (rating == null) return "";
  const rounded = Math.round(rating); // use Math.floor to be more conservative
  const full = Math.max(0, Math.min(5, rounded));
  return "★★★★★☆☆☆☆☆".slice(5 - full, 10 - full); // yields 5 chars
}

